import { TagMaterialType, TagMaterialFinish, TagColor } from './tags';

export const materialPresets = {
  'empty': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/4fed6348-8f8c-47e5-aa33-668412c0b108.png',
    color: '#ffffff'
  },
  'glass': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1db637d5-83f7-4952-a812-55c05f26ab94.png',
    refractive: true,
    roughness: .1,
    metalness: .9,
    opacity: .5,
    color: '#cccccc',
    clearcoat: .9,
    clearcoatRoughness: .25,
    tags: [ TagMaterialType.glass, TagMaterialFinish.glossy ]
  },
  'plastic-basic': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b3af5c25-b292-4609-b64d-230ba4722661.png',
    roughness: 0.1,
    metalness: 0.85,
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b1dfadbe-6c0a-455d-b9a3-a84d6e07dd02.png',
  },
  'tile-basic': {
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bb1fb00f-6cfc-4783-9ef6-cf926eb6a797.png',
    pbrUrl: null,
    clearcoatUrl: null,
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/fb6d255c-5e11-4106-87f8-13e1c2774fb7.png',
    displacementUrl: null,
    displacementScale: null,
    refractive: false,
    reflective: false,
    translucent: false,
    lightSrc: null,
    lightIntensity: 1.0,
    lightUrl: null,
    tags: [ TagMaterialType.floor, TagColor.white ]
  },
  'tile-wooden-floor': {
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/402d0134-b2ad-4beb-85b4-d686010a2cc0.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8984591d-fdb0-4782-85da-36684c5041a8.jpg',
    clearcoatUrl: null,
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    displacementUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/677bc03a-219c-4af6-9056-7347a68ba224.png',
    displacementScale: 0.3,
    refractive: false,
    reflective: false,
    translucent: false,
    lightSrc: null,
    lightIntensity: 1.0,
    lightUrl: null,
    tags: [ TagMaterialType.wood, TagMaterialFinish.glossy, TagColor.orange, TagColor.red ]
  },
  'wall-wallpaper-basic': {
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b1dfadbe-6c0a-455d-b9a3-a84d6e07dd02.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/e4244c51-027d-4676-8a2e-cbd4cad02798.jpg',
    clearcoatUrl: null,
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8741b965-f524-427c-8880-97a7646ee28e.png',
    displacementUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1a4f9cad-c9f3-47bb-ace2-903df32ecea7.png',
    displacementScale: 0.3,
    refractive: false,
    reflective: false,
    translucent: false,
    lightSrc: null,
    lightIntensity: 1.0,
    lightUrl: null,
    tags: [ TagMaterialType.wall, TagColor.blue, TagMaterialFinish.matte ]
  },
  'furniture-basic-1': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/256be3b2-03f5-43fe-a0ca-42cae99751af.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/cf9721c5-5e29-4979-bf1e-118c604547dd.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8984591d-fdb0-4782-85da-36684c5041a8.jpg',
    clearcoatUrl: null,
    normalsUrl: null,
    displacementUrl: null,
    displacementScale: null,
    refractive: false,
    reflective: false,
    translucent: false,
    lightSrc: null,
    lightIntensity: 1.0,
    lightUrl: null,
    tags: [ TagMaterialType.wood, TagMaterialFinish.matte, TagColor.orange, TagColor.red ]
  },
  'space-mat': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b6b6bb51-095b-4838-9723-e447ce0259d5.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b1dfadbe-6c0a-455d-b9a3-a84d6e07dd02.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6c54043e-02b6-48c8-95c7-653fea90dc7e.jpg',
    clearcoatUrl: '',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/fb6d255c-5e11-4106-87f8-13e1c2774fb7.png',
    refractive: false,
    lightUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f58af08a-7a27-42b0-bc33-6c0f1ef070cc.jpg',
    lightSrc: 'rgba(253, 255, 0, 1)',
    lightIntensity: 10,
    opacity: 1,
    clearcoat: '',
    reflective: false,
    tags: [ TagMaterialType.metal, TagColor.gray, TagMaterialFinish.matte ]
  },
  'wood-glossy': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/402d0134-b2ad-4beb-85b4-d686010a2cc0.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f3b6b1f9-90b5-446e-af89-d833e6cd2431.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6c54043e-02b6-48c8-95c7-653fea90dc7e.jpg',
    clearcoatUrl: 'undefined',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d8668539-a50a-4e73-9674-ea2c92ef9912.png',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: '',
    reflective: false,
    tags: [ TagMaterialType.wood, TagMaterialFinish.glossy, TagColor.orange, TagColor.red ]
  },
  'marble': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8f735a71-70df-4ab6-9aa0-4bc2f4d17405.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bb1fb00f-6cfc-4783-9ef6-cf926eb6a797.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d4f9925-1772-4d98-b83d-c1034296d490.jpg',
    clearcoatUrl: '',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/fb6d255c-5e11-4106-87f8-13e1c2774fb7.png',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: '',
    reflective: false,
    tags: [ TagMaterialType.marble, TagMaterialType.wall, TagColor.white, TagMaterialFinish.glossy ]
  },
  'red-paint': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f28a76af-3a9a-4c8b-a0b4-655a7559caca.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6c54043e-02b6-48c8-95c7-653fea90dc7e.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d4f9925-1772-4d98-b83d-c1034296d490.jpg',
    clearcoatUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6c54043e-02b6-48c8-95c7-653fea90dc7e.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: '',
    reflective: false,
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagColor.red, TagMaterialFinish.matte ]
  },
  'blue-paint': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3d0f6e16-ea36-4c77-9be8-fdfd7bc25e0d.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b1dfadbe-6c0a-455d-b9a3-a84d6e07dd02.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d4f9925-1772-4d98-b83d-c1034296d490.jpg',
    clearcoatUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6c54043e-02b6-48c8-95c7-653fea90dc7e.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: '',
    reflective: false,
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagColor.blue, TagMaterialFinish.matte ]
  },
  'yellow-paint': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3217711d-406c-4602-8718-9cf15d00ee71.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/e4244c51-027d-4676-8a2e-cbd4cad02798.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d4f9925-1772-4d98-b83d-c1034296d490.jpg',
    clearcoatUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6c54043e-02b6-48c8-95c7-653fea90dc7e.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: '',
    reflective: false,
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagColor.yellow, TagMaterialFinish.matte ]
  },
  'wood-and-black-metal': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f4c54543-312f-4680-ba96-17cf624b44ff.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b77a7a1f-2939-4246-8b9d-b0bcec0a5bac.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8984591d-fdb0-4782-85da-36684c5041a8.jpg',
    clearcoatUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6c54043e-02b6-48c8-95c7-653fea90dc7e.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d8668539-a50a-4e73-9674-ea2c92ef9912.png',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: '',
    reflective: false,
    tags: [ TagMaterialType.metal, TagMaterialType.plastic, TagColor.black, TagMaterialFinish.glossy ]
  },
  'castle-wall': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f6b49a79-9480-44ea-9c7b-bfddd2385e10.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bdf2b71e-fcd3-4db4-83ed-1eaea29c813d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8984591d-fdb0-4782-85da-36684c5041a8.jpg',
    clearcoatUrl: '',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/608b8dc2-77ec-4cf3-be8e-585649f6ea02.jpg',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: 0,
    reflective: false,
    tags: [ TagMaterialType.bricks, TagMaterialType.wall, TagColor.gray, TagMaterialFinish.matte ]
  },
  'castle-floor': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/ed0c2a22-e502-48f3-8f48-6ced5f154817.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/285b01c3-f6a5-4d04-a996-7cec2991c7f8.jpg',
    sharpenTexture: false,
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8984591d-fdb0-4782-85da-36684c5041a8.jpg',
    clearcoatUrl: '',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/02f82029-8de2-4245-856f-689c7bbf774a.jpg',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: 0,
    reflective: false,
    tags: [ TagMaterialType.floor, TagMaterialType.bricks, TagColor.gray, TagMaterialFinish.matte ]
  },
  'grass': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/19e8dd1b-920b-47cc-a8c6-1c206a64a531.png',
    color: '#6b6c15',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/15041ec1-fb6f-41be-ba4c-d154ebb19d3c.png',
    sharpenTexture: true,
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8984591d-fdb0-4782-85da-36684c5041a8.jpg',
    clearcoatUrl: null,
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/ecdfe840-ca35-469e-94cb-28f26a984c8a.png',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: 0,
    reflective: false,
    tags: [ TagColor.green, TagMaterialType.floor ]
  },
  'clear': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c1cd253e-465e-4325-b9e9-e07db63044b3.png',
    color: '#ffffff',
    textureUrl: null,
    sharpenTexture: false,
    pbrUrl: null,
    clearcoatUrl: null,
    normalsUrl: null,
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: 0,
    reflective: false,
    roughness: .7,
    metalness: .5,
    tags: [ TagColor.white, TagMaterialFinish.glossy ]
  },
  'unpainted-wall': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/ab9b870e-7294-4a43-ac40-55d194880a8b.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f25bfdf1-43ac-4bd4-ad94-b3f039ad3038.png',
    sharpenTexture: false,
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8984591d-fdb0-4782-85da-36684c5041a8.jpg',
    clearcoatUrl: null,
    normalsUrl: null,
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: 0,
    reflective: false,
    tags: [ TagColor.gray, TagMaterialFinish.matte ]
  },
  'unpainted-floor': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/2d169fc1-139a-458a-b2d3-1dd23bfca7d2.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/89231692-288a-4403-b948-2e68b230b58a.png',
    sharpenTexture: false,
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8984591d-fdb0-4782-85da-36684c5041a8.jpg',
    clearcoatUrl: '',
    normalsUrl: '',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: 0,
    reflective: false,
    tags: [ TagColor.gray, TagMaterialFinish.matte ]
  },
  'industrial-concrete': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0fe64a2f-11f6-451b-9376-67a08ae5ebad.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/646c4dd8-8210-4164-8c87-88ce17ba596d.jpg',
    sharpenTexture: false,
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1fe1916d-e7b6-42dc-8c36-840336f41a97.jpg',
    clearcoatUrl: '',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b8596382-e0a9-40db-9a9c-3b0f9f9841fb.jpg',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: '',
    reflective: false,
  },
  'metal': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0083e01d-615b-417c-b758-993841a3a8e2.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/479716a0-42c4-4604-903d-5ebf4d463618.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/865f5726-bb24-4cd2-85f1-bd32af796684.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6ff64d3e-2d28-4720-95e5-608c5ffc5510.jpg',
    color: '#555555',
    tags: [ TagMaterialFinish.glossy, TagMaterialType.metal ]
  },
  'metal-rough': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/154b61fc-1b76-4acd-8fb3-4756ce3c5a5d.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/646c4dd8-8210-4164-8c87-88ce17ba596d.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bbf08cd8-d282-4ce4-a644-51a54c96e898.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1fe1916d-e7b6-42dc-8c36-840336f41a97.jpg',
    color: '#555555',
    tags: [ TagMaterialFinish.matte, TagMaterialType.metal ]
  },
  'brick-wall': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/68a8b322-9859-4c13-8299-07ae3a76dd62.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/56cb8660-fd90-4878-a864-7565a22d1c56.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6464d8be-3c1c-479b-b532-85cf5e78db7c.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8c7ad852-876c-4516-b729-88dea8195832.jpg',
    color: '#b6a193',
    tags: [ TagMaterialType.bricks, TagMaterialType.wall, TagColor.red, TagMaterialFinish.matte ]
  },
  'brick-wall-white': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/678a1e4f-ad11-404c-9d57-774bba43cdbe.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b6bdf21c-10b1-4f10-890b-9007cb1afc03.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6464d8be-3c1c-479b-b532-85cf5e78db7c.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8c7ad852-876c-4516-b729-88dea8195832.jpg',
    color: '#cccccc',
    tags: [ TagMaterialType.bricks, TagMaterialType.wall, TagColor.white, TagMaterialFinish.matte ]
  },
  'brick-wall-red': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/710ee293-9f18-4f78-a061-678a75d5eeed.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b6bdf21c-10b1-4f10-890b-9007cb1afc03.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6464d8be-3c1c-479b-b532-85cf5e78db7c.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8c7ad852-876c-4516-b729-88dea8195832.jpg',
    color: '#481C1C',
    tags: [ TagMaterialType.bricks, TagMaterialType.wall, TagColor.red, TagMaterialFinish.matte ]
  },
  'brick-wall-gray': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a9c9a3dd-ceec-4019-97f6-49df04afcbd1.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b6bdf21c-10b1-4f10-890b-9007cb1afc03.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6464d8be-3c1c-479b-b532-85cf5e78db7c.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8c7ad852-876c-4516-b729-88dea8195832.jpg',
    color: '#413A2E',
    tags: [ TagMaterialType.bricks, TagMaterialType.wall, TagColor.gray, TagMaterialFinish.matte ]
  },
  'brick-wall-black': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/ea1863a2-aa66-48de-a551-7454a55ab795.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b6bdf21c-10b1-4f10-890b-9007cb1afc03.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6464d8be-3c1c-479b-b532-85cf5e78db7c.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8c7ad852-876c-4516-b729-88dea8195832.jpg',
    color: '#292429',
    tags: [ TagMaterialType.bricks, TagMaterialType.wall, TagColor.gray, TagColor.brown, TagMaterialFinish.matte ]
  },
  'brick-wall-tan': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1aeb55c9-dea3-475d-bc6a-4d2a4b4f5463.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b6bdf21c-10b1-4f10-890b-9007cb1afc03.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6464d8be-3c1c-479b-b532-85cf5e78db7c.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8c7ad852-876c-4516-b729-88dea8195832.jpg',
    color: '#cdc09c',
    tags: [ TagMaterialType.bricks, TagMaterialType.wall, TagColor.yellow, TagColor.brown, TagMaterialFinish.matte ]
  },
  'brick-facade-cross': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d8307969-7f2b-4a4c-92ca-c112849adf97.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5eec63d4-983b-4d85-a5f0-0e0f00e19e71.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/187de97e-5b16-4959-a3d5-4bb645cd65f2.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d9d61923-99ac-4268-8f4d-b744aa08651d.png',
    color: '#cfcbc8',
    tags: [ TagMaterialType.bricks, TagMaterialType.wall, TagColor.brown, TagMaterialFinish.matte ]
  },
  'brick-facade-cross-light': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/091ad574-ed5b-4343-b895-3a7de83f40ce.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5eec63d4-983b-4d85-a5f0-0e0f00e19e71.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/187de97e-5b16-4959-a3d5-4bb645cd65f2.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d9d61923-99ac-4268-8f4d-b744aa08651d.png',
    color: '#BFB17D',
    tags: [ TagMaterialType.bricks, TagMaterialType.wall, TagColor.yellow, TagMaterialFinish.matte ]
  },
  'brick-facade-cross-dark': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/30525ef9-971b-4729-8d0a-fae52bfc4a9b.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5eec63d4-983b-4d85-a5f0-0e0f00e19e71.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/187de97e-5b16-4959-a3d5-4bb645cd65f2.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d9d61923-99ac-4268-8f4d-b744aa08651d.png',
    color: '#33312A',
    tags: [ TagMaterialType.bricks, TagMaterialType.wall, TagColor.black, TagMaterialFinish.matte ]
  },
  'brick-facade': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/660d771d-b61a-43fe-8aff-c8d39f72d796.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c26b8bbd-4c2e-499b-9a02-ed1a779e760b.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/187de97e-5b16-4959-a3d5-4bb645cd65f2.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c8beff51-73e0-4702-92ea-916bbe51033b.png',
    color: '#7B7767',
    tags: [ TagMaterialType.bricks, TagMaterialType.wall, TagColor.white, TagColor.brown, TagMaterialFinish.matte ]
  },
  'brick-facade-light': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/af575bd3-de35-4b5d-b5d8-d8d624a3848d.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c26b8bbd-4c2e-499b-9a02-ed1a779e760b.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/187de97e-5b16-4959-a3d5-4bb645cd65f2.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c8beff51-73e0-4702-92ea-916bbe51033b.png',
    color: '#dddedf',
    tags: [ TagMaterialType.bricks, TagMaterialType.wall, TagColor.white, TagColor.brown, TagMaterialFinish.matte ]
  },
  'brick-facade-dark': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a54bc965-0644-4622-bed1-933038661994.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c26b8bbd-4c2e-499b-9a02-ed1a779e760b.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/187de97e-5b16-4959-a3d5-4bb645cd65f2.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c8beff51-73e0-4702-92ea-916bbe51033b.png',
    color: '#1A1917',
    tags: [ TagMaterialType.bricks, TagMaterialType.wall, TagColor.white, TagColor.brown, TagMaterialFinish.matte ]
  },
  'wallpaper-matte-red': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5dc796ad-d163-4d81-80fa-1871b36ccb90.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#BB2525',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.red ]
  },
  'wallpaper-halfmatte-red': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/21576b96-8525-4dff-bd1d-caaaa882b7e2.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#BB2525',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.red ]
  },
  'wallpaper-glossy-red': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0ba225bf-a75c-4372-a255-963d5bd3b19f.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8162f1af-66bb-41ac-8ab9-d68f8bad9097.png',
    color: '#BB2525',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.red ]
  },
  'wallpaper-matte-orange': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/da3e06c5-756e-40f4-98be-db445ed4b1b1.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#BF6D04',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.orange ]
  },
  'wallpaper-halfmatte-orange': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05b3802c-d4f4-4927-8c84-8f38583841c7.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#BF6D04',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.orange ]
  },
  'wallpaper-glossy-orange': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/38ff5bf8-50af-48ce-9b15-79bc2ff70ce6.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#BF6D04',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.orange ]
  },
  'wallpaper-matte-yellow': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b7c7d0d7-4ad5-463e-9b7d-dbf0cf93243e.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#FFF727',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.yellow ]
  },
  'wallpaper-halfmatte-yellow': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/ebf4ec04-43c2-4aca-89c6-d181c0ca7ea0.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#FFF727',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.yellow ]
  },
  'wallpaper-glossy-yellow': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/fcbcb8ad-2e61-4b3d-bd8a-9a99c07d7e0a.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#FFF727',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.yellow ]
  },
  'wallpaper-matte-marsh': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0494436e-d6ba-441e-b899-806c3a4570f0.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#81901C',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.yellow ]
  },
  'wallpaper-halfmatte-marsh': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5b5466a6-0e82-411c-81f9-b506512f200e.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#81901C',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.yellow ]
  },
  'wallpaper-glossy-marsh': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f52e85b1-9def-42f6-96e1-2ef5758782e0.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#81901C',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.yellow ]
  },
  'wallpaper-matte-green': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7657d869-218d-4d03-af04-775b671f7cd1.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#3ABB34',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.green ]
  },
  'wallpaper-halfmatte-green': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/61f9865a-9431-4dce-aa81-daf0522cd9ef.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#3ABB34',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.green ]
  },
  'wallpaper-glossy-green': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/e1a549b9-d3f5-4915-a19f-6e6f4fb3e8b8.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#3ABB34',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.green ]
  },
  'wallpaper-matte-ocean': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0691db5e-0e8f-4dca-9eba-195c474d039c.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#239A7D',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.green ]
  },
  'wallpaper-halfmatte-ocean': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/240f5cfb-6db4-4c89-b63a-1f3940ec5731.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#239A7D',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.green ]
  },
  'wallpaper-glossy-ocean': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f96fb0df-518b-486a-aba0-1107ae841e54.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#239A7D',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.green ]
  },
  'wallpaper-matte-blue': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/eb2b4a0d-dcfc-4cfe-970b-9ee461ebacb4.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#23709A',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.blue ]
  },
  'wallpaper-halfmatte-blue': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/9d224700-7158-48a6-8bb7-61f8c7cfd710.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#23709A',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.blue ]
  },
  'wallpaper-glossy-blue': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1fde50fe-5e1f-4f76-b650-21e4e94a74b8.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#23709A',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.blue ]
  },
  'wallpaper-matte-dark-blue': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/2d6f74c8-0271-477c-83c6-82001b4cbf6f.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#2743B1',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.blue ]
  },
  'wallpaper-halfmatte-dark-blue': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/98f3d2c8-c6c7-4f53-9478-d490f1ae004b.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#2743B1',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.blue ]
  },
  'wallpaper-glossy-dark-blue': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c70b7c64-f473-4615-9f94-edd6828a9abf.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#2743B1',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.blue ]
  },
  'wallpaper-matte-purple': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/79d80009-a289-4d39-b0ab-438977b85447.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#482998',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.violet ]
  },
  'wallpaper-halfmatte-purple': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/9fbe06d7-f5d2-494e-baad-d76fedfe2076.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#482998',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.violet ]
  },
  'wallpaper-glossy-purple': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/814976e4-d30c-418f-b95c-5e60dd6e9d29.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#482998',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.violet ]
  },
  'wallpaper-matte-pink': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d2e8b733-f0e4-468b-ac43-330095ba8642.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#A263AB',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.pink ]
  },
  'wallpaper-halfmatte-pink': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b674a50b-06e9-4eaf-8053-9f64ca55e301.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#A263AB',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.pink ]
  },
  'wallpaper-glossy-pink': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/51de79d6-3c6c-45a5-99ff-f6604bff1637.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#A263AB',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.pink ]
  },
  'wallpaper-matte-brown': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a1146953-a5bb-4399-a80b-40cbf7fecb29.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#3F3831',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.brown ]
  },
  'wallpaper-halfmatte-brown': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b4768b46-cb1b-41b1-bb75-45b0d2180c68.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#3F3831',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.brown ]
  },
  'wallpaper-glossy-brown': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d1cb46d7-c035-4248-9bfe-f128073b9659.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#3F3831',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.brown ]
  },
  'wallpaper-matte-eggshell': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/37e57772-7847-42b0-9c22-62bd32f98e02.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#FBF6E6',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.yellow ]
  },
  'wallpaper-halfmatte-eggshell': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f54e830f-a385-44c4-9b98-51798ad19b52.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#FBF6E6',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.yellow ]
  },
  'wallpaper-glossy-eggshell': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3cdc644f-d78e-421f-b3e5-1a8cc88cca1c.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#FBF6E6',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.yellow ]
  },
  'wallpaper-matte-white': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/99e6e584-06f8-46a8-810c-31ccf2436d03.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#EEEEEE',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.yellow ]
  },
  'wallpaper-halfmatte-white': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7048d5bb-e4a3-4f35-bcd8-5f732ec38749.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#EEEEEE',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.yellow ]
  },
  'wallpaper-glossy-white': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/82e4853f-4452-4817-bcd8-a1daccc785b6.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#EEEEEE',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.yellow ]
  },
  'wallpaper-matte-gray': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a75db7b4-fc69-4895-8214-32cfb7f6be80.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#736F6F',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.gray ]
  },
  'wallpaper-halfmatte-gray': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/2ba88535-f699-4266-81bf-16406e41ffeb.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#736F6F',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.gray ]
  },
  'wallpaper-glossy-gray': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/059fb5f3-98c8-42b9-9b69-41510f8b3d2c.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#736F6F',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.gray ]
  },
  'wallpaper-matte-black': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/4c2746b5-4f0b-466c-a151-b98a127b8166.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    color: '#222222',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.matte, TagColor.yellow ]
  },
  'wallpaper-halfmatte-black': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6956e930-db60-4c69-bc08-9de141895d24.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#222222',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.yellow ]
  },
  'wallpaper-glossy-black': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/e5e5565e-1626-480d-b633-81b6e2d774bf.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/819de472-6348-4446-9468-c5446eb7515d.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0420166d-1ec8-43eb-b554-421e54137165.png',
    color: '#222222',
    tags: [ TagMaterialType.paint, TagMaterialType.wall, TagMaterialFinish.glossy, TagColor.yellow ]
  },
  'carpet-brown': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/854e4247-9e6f-4ad1-be49-628acaabb0b6.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c0f645f7-9284-428f-b4f6-4feaadbe8a6f.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6932b456-9f97-48e6-8dbb-73d7c5d1609e.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/311b868a-3290-4167-bf15-a0c5df40c4e8.png',
    color: '#ccb192',
    tags: [ TagMaterialType.floor, TagMaterialFinish.matte, TagColor.brown ]
  },
  'carpet-white': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/04ffb55a-e0f5-4169-9e8e-5be5af4d09e9.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d116256f-f9ed-43cd-b4b6-83261f22c851.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6932b456-9f97-48e6-8dbb-73d7c5d1609e.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/311b868a-3290-4167-bf15-a0c5df40c4e8.png',
    color: '#dbdcde',
    tags: [ TagMaterialType.floor, TagMaterialFinish.matte, TagColor.white ]
  },
  'carpet-red': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/9ec35511-ce7b-4b1c-91f3-d58ac2e61c37.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d116256f-f9ed-43cd-b4b6-83261f22c851.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6932b456-9f97-48e6-8dbb-73d7c5d1609e.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/311b868a-3290-4167-bf15-a0c5df40c4e8.png',
    color: '#C91616',
    tags: [ TagMaterialType.floor, TagMaterialFinish.matte, TagColor.red ]
  },
  'carpet-blue': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/9af5f8f9-b1ab-4ce2-942d-e40b707f2c8e.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d116256f-f9ed-43cd-b4b6-83261f22c851.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6932b456-9f97-48e6-8dbb-73d7c5d1609e.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/311b868a-3290-4167-bf15-a0c5df40c4e8.png',
    color: '#232CEC',
    tags: [ TagMaterialType.floor, TagMaterialFinish.matte, TagColor.blue ]
  },
  'carpet-yellow': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/42a00d92-3679-4087-b3be-350ab8cb768e.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d116256f-f9ed-43cd-b4b6-83261f22c851.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6932b456-9f97-48e6-8dbb-73d7c5d1609e.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/311b868a-3290-4167-bf15-a0c5df40c4e8.png',
    color: '#B7A507',
    tags: [ TagMaterialType.floor, TagMaterialFinish.matte, TagColor.yellow ]
  },
  'carpet-deep-blue': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/79d8fb3a-384e-4949-9609-c64781fab2b0.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d116256f-f9ed-43cd-b4b6-83261f22c851.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6932b456-9f97-48e6-8dbb-73d7c5d1609e.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/311b868a-3290-4167-bf15-a0c5df40c4e8.png',
    color: '#0D274A',
    tags: [ TagMaterialType.floor, TagMaterialFinish.matte, TagColor.blue ]
  },
  'carpet-deep-red': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a15a9039-1518-4d52-8fc1-1bef0014970b.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d116256f-f9ed-43cd-b4b6-83261f22c851.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6932b456-9f97-48e6-8dbb-73d7c5d1609e.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/311b868a-3290-4167-bf15-a0c5df40c4e8.png',
    color: '#4A0D0D',
    tags: [ TagMaterialType.floor, TagMaterialFinish.matte, TagColor.red ]
  },
  'carpet-gold': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7e0032f9-edcb-4c69-9e80-3e70212bd339.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d116256f-f9ed-43cd-b4b6-83261f22c851.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6932b456-9f97-48e6-8dbb-73d7c5d1609e.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/311b868a-3290-4167-bf15-a0c5df40c4e8.png',
    color: '#674F0B',
    tags: [ TagMaterialType.floor, TagMaterialFinish.matte, TagColor.brown ]
  },
  'carpet-ocean': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a0e67975-2f69-4a27-b707-e1cb421a1365.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d116256f-f9ed-43cd-b4b6-83261f22c851.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6932b456-9f97-48e6-8dbb-73d7c5d1609e.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/311b868a-3290-4167-bf15-a0c5df40c4e8.png',
    color: '#105FA4',
    tags: [ TagMaterialType.floor, TagMaterialFinish.matte, TagColor.blue]
  },
  'wood-1': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/97e19196-cb2d-4ad6-a0c7-dc1341ef0923.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7a3cd7b8-b868-47fd-9c93-5014c07b0052.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7ebc6101-379e-407b-b80c-f0947dbcc1cc.png',
    clearcoatUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/252a5956-0a90-4c3e-a8f0-9e33ddc55a1b.png',
    color: '#A49B9B',
    tags: [ TagMaterialType.floor, TagMaterialFinish.glossy, TagMaterialType.wood, TagColor.brown ]
  },
  'wood-2': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/2da11810-4acf-4710-8d5d-1c46f556e93a.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7a3cd7b8-b868-47fd-9c93-5014c07b0052.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7ebc6101-379e-407b-b80c-f0947dbcc1cc.png',
    clearcoatUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/252a5956-0a90-4c3e-a8f0-9e33ddc55a1b.png',
    color: '#4E4949',
    tags: [ TagMaterialType.floor, TagMaterialFinish.glossy, TagMaterialType.wood, TagColor.brown, TagColor.black ]
  },
  'wood-3': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/68bc9f5b-a4ec-42f5-9d65-e8c5bfa76b9f.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7a3cd7b8-b868-47fd-9c93-5014c07b0052.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7ebc6101-379e-407b-b80c-f0947dbcc1cc.png',
    clearcoatUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/252a5956-0a90-4c3e-a8f0-9e33ddc55a1b.png',
    color: '#332A1C',
    tags: [ TagMaterialType.floor, TagMaterialFinish.glossy, TagMaterialType.wood, TagColor.brown, TagColor.red ]
  },
  'tiles-1': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/cff8c976-5f06-4a06-80d5-888ee0c4003c.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/42fd525b-5a0f-498a-833b-6d30b9abde4d.png',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/43571022-37dc-41af-9c6e-7a162ca2ee63.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/ce2e67ca-d321-47b2-93cc-3eeea5965c10.png',
    color: '#e3e3e4',
    tags: [ TagMaterialType.floor, TagMaterialFinish.glossy, TagColor.white, TagColor.black ]
  },
  'tiles-2': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1a36d3e5-4e72-4350-b951-bc00a779fa03.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d82dfbac-b0be-4a6f-b5d7-3c7cb281574a.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c035eb51-120a-483a-9236-537bc8adb8b5.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c035eb51-120a-483a-9236-537bc8adb8b5.png',
    color: '#b3b7b9',
    tags: [ TagMaterialType.floor, TagMaterialFinish.matte, TagColor.white, TagMaterialType.marble ]
  },
  'tiles-3': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1257b900-460f-4832-a372-9b8daa109edf.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c1f42be2-1d10-4dd2-8eb7-c527384c9374.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6275f448-af63-438e-983a-ad4be7f860d3.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6da24b81-fb50-4b11-b214-d8539882c885.png',
    clearcoatUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6275f448-af63-438e-983a-ad4be7f860d3.png',
    color: '#d9dadc',
    tags: [ TagMaterialType.floor, TagMaterialFinish.glossy, TagColor.white, TagColor.black ]
  },
  'tiles-4': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/208d88ee-90a0-4e92-ba6e-fcb00fe9f97c.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c1f42be2-1d10-4dd2-8eb7-c527384c9374.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6275f448-af63-438e-983a-ad4be7f860d3.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6da24b81-fb50-4b11-b214-d8539882c885.png',
    clearcoatUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6275f448-af63-438e-983a-ad4be7f860d3.png',
    color: '#111111',
    tags: [ TagMaterialType.floor, TagMaterialFinish.glossy, TagColor.black ]
  },
  'tiles-rough-1': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5ac6952d-30bf-45d3-9a3a-c665bd99b562.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b294bd18-25ee-45a3-b92c-5b94e8da72bf.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a4f74da7-a512-4470-84c9-def83a3dfd62.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/252a5956-0a90-4c3e-a8f0-9e33ddc55a1b.png',
    color: '#c6c5c2',
    tags: [ TagMaterialType.floor, TagMaterialFinish.matte, TagColor.black, TagColor.gray, TagMaterialType.bricks ]
  },
  'tile-rough-2': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/18556380-0902-4bec-860e-f5dd40b204e3.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/e60082be-f780-419d-90f4-dfa1bee537cf.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/dd14a2e7-bee2-4c2e-bf2a-89402465097e.png',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/e737f729-d949-46d7-a331-236f29b2a57c.png',
    color: '#dbc8b6',
    tags: [ TagMaterialType.floor, TagMaterialFinish.matte, TagColor.yellow, TagColor.red, TagMaterialType.bricks ]
  },
  'construction-plaster': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b9ae04df-ae80-4351-aae5-9b3980d87035.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7c83265f-0f3a-4399-87af-c59de34fdd87.jpg',
    sharpenTexture: false,
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/06fc87f3-1304-4c6f-b08f-12f6625e778b.jpg',
    clearcoatUrl: '',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5956f1b7-b160-469c-9f34-d8067a6232ac.jpg',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: 0,
    reflective: false,
  },
  'hg-wood-mood': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/146a95ee-eee5-40bc-a67f-1ecdbd87c26b.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c0214032-ca3d-4e51-baff-6ed48fd478e2.jpg',
    sharpenTexture: false,
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/495927dd-a5a7-47bd-bff0-8aab9363719a.jpg',
    clearcoatUrl: '',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/85dbe9e6-dc14-4993-bf0e-e7d69afc8359.jpg',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: 0,
    reflective: false,
  },
  'hg-wood-essence': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8ce01fbb-d917-4681-ac9b-88dd4786e73f.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/60e761a6-c793-4ad9-88ab-6c838c989177.jpg',
    sharpenTexture: false,
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/495927dd-a5a7-47bd-bff0-8aab9363719a.jpg',
    clearcoatUrl: '',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d2bd74f5-0abd-4b22-a6cf-b7338ac063b7.jpg',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: 0,
    reflective: false,
  },
  'hg-wood-aroma': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/e39e6dc5-8a4a-4b08-9b1b-ab9fbfad6ce2.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/570bb8fe-f4c6-4367-919b-a08902b29494.jpg',
    sharpenTexture: false,
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/495927dd-a5a7-47bd-bff0-8aab9363719a.jpg',
    clearcoatUrl: '',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/02f1b2a9-334a-492e-a610-8a533d9f04c0.jpg',
    refractive: false,
    lightUrl: '',
    lightSrc: '',
    lightIntensity: 1,
    opacity: 1,
    clearcoat: 0,
    reflective: false,
  },
  'ikea-white-white': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3cdc644f-d78e-421f-b3e5-1a8cc88cca1c.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/e29a6025-afa3-4fb0-993d-5fc2a5a89159.jpg',
    color: '#ffffff',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/187de97e-5b16-4959-a3d5-4bb645cd65f2.jpg',
    tags: [ TagMaterialType.wood, TagMaterialType.plastic, TagColor.white, TagMaterialFinish.matte ]
  },
  'ikea-white-black': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/4c2746b5-4f0b-466c-a151-b98a127b8166.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/2a8a3a07-49f8-435c-bfb7-ae59f33d3f44.jpg',
    color: '#ffffff',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/187de97e-5b16-4959-a3d5-4bb645cd65f2.jpg',
    tags: [ TagMaterialType.wood, TagMaterialType.plastic, TagColor.white, TagColor.black, TagMaterialFinish.matte ]
  },
  'ikea-white-blue': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/eb2b4a0d-dcfc-4cfe-970b-9ee461ebacb4.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0d5abf9e-bc5e-4886-9056-54c8ff926f5f.jpg',
    color: '#ffffff',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/187de97e-5b16-4959-a3d5-4bb645cd65f2.jpg',
    tags: [ TagMaterialType.wood, TagMaterialType.plastic, TagColor.white, TagColor.blue, TagMaterialFinish.matte ]
  },
  'ikea-white-pink': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d2e8b733-f0e4-468b-ac43-330095ba8642.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/92e86fa9-2110-4816-a4cc-4cee23c156c3.jpg',
    color: '#ffffff',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/187de97e-5b16-4959-a3d5-4bb645cd65f2.jpg',
    tags: [ TagMaterialType.wood, TagMaterialType.plastic, TagColor.white, TagColor.pink, TagMaterialFinish.matte ]
  },
  'ikea-white-red': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5dc796ad-d163-4d81-80fa-1871b36ccb90.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/dfb90d72-2d70-4d20-b4c7-8f6be0464012.jpg',
    color: '#ffffff',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/187de97e-5b16-4959-a3d5-4bb645cd65f2.jpg',
    tags: [ TagMaterialType.wood, TagMaterialType.plastic, TagColor.white, TagColor.red, TagMaterialFinish.matte ]
  },
  'ikea-sundvik-wardrobe': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a1146953-a5bb-4399-a80b-40cbf7fecb29.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/805a4df2-4a5a-48ee-9a4f-ab3d57504fb5.png',
    color: '#2e1f13',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/63afb2fb-a823-4747-a8f3-f29310ce7644.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/390ff363-749d-47bd-b7d6-4d1b47937346.jpg',
    tags: [ TagMaterialType.wood, TagMaterialFinish.matte ]
  },
  'ikea-poang-beige': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/ebf4ec04-43c2-4aca-89c6-d181c0ca7ea0.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/70c9c6a7-65c5-461a-b043-bcccd000534e.jpg',
    color: '#d6d1ce',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/187de97e-5b16-4959-a3d5-4bb645cd65f2.jpg',
    tags: [ TagMaterialType.wood, TagColor.white, TagColor.yellow, TagMaterialFinish.matte ]
  },
  'eames-dark-gray': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/4c2746b5-4f0b-466c-a151-b98a127b8166.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d388b822-7bef-4d17-8503-45b6c3a94a15.png',
    color: '#272727',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.gray, TagColor.black ]
  },
  'eames-parchment': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/ebf4ec04-43c2-4aca-89c6-d181c0ca7ea0.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/32288971-2a6c-43d0-bb2e-903d29ebdd09.jpg',
    color: '#d6d1ce',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.yellow, TagColor.green ]
  },
  'eames-light-gray': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a75db7b4-fc69-4895-8214-32cfb7f6be80.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/fe215948-984a-41d9-8b2b-604eadf57872.png',
    color: '#868686',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.gray ]
  },
  'eames-dark-green': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0494436e-d6ba-441e-b899-806c3a4570f0.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3a1ea03b-a652-4898-bf41-a1e7178a607b.png',
    color: '#7b846b',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.green ]
  },
  'eames-deep-black': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6956e930-db60-4c69-bc08-9de141895d24.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b740e427-38a7-4b9f-a2d6-c8ef42cd356d.png',
    color: '#111',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.black ]
  },
  'eames-green': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7657d869-218d-4d03-af04-775b671f7cd1.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/10cb5529-fbad-4215-a0d4-bc3e6b5fde20.png',
    color: '#669148',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.green ]
  },
  'eames-mustard': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a1146953-a5bb-4399-a80b-40cbf7fecb29.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b599985e-d699-40a3-b714-cefce3154ad6.png',
    color: '#bd9f5d',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.yellow ]
  },
  'eames-pale-rose': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d2e8b733-f0e4-468b-ac43-330095ba8642.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/99bfff0a-4cd4-43df-8d94-02d8f62585c9.png',
    color: '#ffb8c4',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.pink ]
  },
  'eames-ice-gray': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/059fb5f3-98c8-42b9-9b69-41510f8b3d2c.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/90948a90-23f7-4141-ac28-37c0f60325cc.png',
    color: '#97a4a4',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.white, TagColor.gray ]
  },
  'eames-pebble': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b4768b46-cb1b-41b1-bb75-45b0d2180c68.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/ad80ffd9-beab-4e64-bc5d-e1ea2290356f.png',
    color: '#cdc0a3',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.brown ]
  },
  'eames-poppy-red': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/21576b96-8525-4dff-bd1d-caaaa882b7e2.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c5cd23fb-0759-473f-9b8e-a2faaa18f4d9.png',
    color: '#de334f',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.red ]
  },
  'eames-rusty-orange': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/da3e06c5-756e-40f4-98be-db445ed4b1b1.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/26b9a441-04f2-4c9d-a96f-3e147a4e529f.png',
    color: '#de6c32',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.orange ]
  },
  'eames-sea-blue': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/2d6f74c8-0271-477c-83c6-82001b4cbf6f.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/01328da8-2318-4f5b-8855-b4225937f0d0.png',
    color: '#57657f',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.blue ]
  },
  'eames-sunlight': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b7c7d0d7-4ad5-463e-9b7d-dbf0cf93243e.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5869cc6d-2b31-46c7-9984-139dcb796c2a.png',
    color: '#ffc23c',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.yellow, TagColor.orange ]
  },
  'eames-white': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/99e6e584-06f8-46a8-810c-31ccf2436d03.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/34007fda-46e0-4b70-972f-102838f409c7.png',
    color: '#fff',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.white ]
  },
  'eames-blood-red': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5dc796ad-d163-4d81-80fa-1871b36ccb90.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bdc5c3fb-080d-435d-bf1f-ae8315b128e7.png',
    color: '#722c29',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.red ]
  },
  'eames-dark-oak': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6956e930-db60-4c69-bc08-9de141895d24.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/eaa1e610-e4db-4914-957c-bb090e87f084.png',
    color: '#272727',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.wood, TagColor.black ]
  },
  'eames-multicolor': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6956e930-db60-4c69-bc08-9de141895d24.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/629de1c8-37c5-4f10-987d-e9c1bd38a2cb.png',
    color: '#aab4b9',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.metal, TagMaterialType.plastic, TagColor.black, TagColor.red, TagColor.orange, TagColor.blue,, TagColor.brown ]
  },
  'eames-multicolor-2': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6956e930-db60-4c69-bc08-9de141895d24.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3d913cda-ac3b-4656-975f-6428c9d7d491.png',
    color: '#aab4b9',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.metal, TagMaterialType.plastic, TagColor.black, TagColor.red, TagColor.orange, TagColor.blue,, TagColor.brown ]
  },
  'cando-black-and-white': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6956e930-db60-4c69-bc08-9de141895d24.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/eaa1e610-e4db-4914-957c-bb090e87f084.png',
    color: '#272727',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    tags: [ TagMaterialType.wood, TagColor.black ]
  },
  'cando-achterdeur-green': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0494436e-d6ba-441e-b899-806c3a4570f0.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0c5d489a-4a56-402c-ad52-3e2884abc5bf.png',
    color: '#2f4b41',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    tags: [ TagMaterialType.wood, TagColor.green ]
  },
  'cando-voordeur-light': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b4768b46-cb1b-41b1-bb75-45b0d2180c68.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3b999c42-0991-48da-949b-b63a0fa39457.png',
    color: '#cdc0a3',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    tags: [ TagMaterialType.wood, TagColor.white ]
  },
  'cando-voordeur-dark': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c70b7c64-f473-4615-9f94-edd6828a9abf.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/fe23bb0d-c25e-4023-addf-51aa0feabf64.png',
    color: '#485374',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d98bae6-2455-4c5b-bde8-3799c8c502b5.png',
    tags: [ TagMaterialType.wood, TagColor.blue ]
  },
  'water': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/93b5bb07-6622-414c-a2ac-5fef827f40a4.png',
    color: '#ffffff',
    opacity: 0,
    tags: [ TagMaterialType.water ]
  },
  'ground-concrete': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/69fd7c88-5f82-4687-a388-925b418817f0.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/98bf8f20-1b41-4034-afd3-9f160af7d2c4.jpg',
    color: '#333333',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f3c6e5e7-eb32-4208-b824-7e85196ccdd8.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/74f48412-28c5-4344-9907-b78b5da205d8.jpg',
    tags: [ TagMaterialType.road ]
  },
  'ground-forest': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/02e88f21-9530-4b4f-b387-c9a35434729a.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/55b69688-aeef-4547-996f-9c1ec3f3b491.jpg',
    color: '#876b5c',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d002cf65-bdc3-4cb6-92e1-9f897f323b63.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/43845518-47b4-436e-9cb8-b8786c43c844.jpg',
    tags: [ TagMaterialType.road ]
  },
  'ground-forest-2': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/19e8dd1b-920b-47cc-a8c6-1c206a64a531.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/4e8789d9-79b9-40a6-b692-6b2350c9ae3a.jpg',
    color: '#6b6c15',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a1b62ec2-425f-4e6f-bd6b-6e858ac77bb3.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/835890be-b623-4253-b918-b3949eb6697c.jpg',
    tags: [ TagMaterialType.road ]
  },
  'ground-gravel': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b9dc43ab-1e80-4c8a-b01c-7946e765a8dc.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0f3eb8e1-8ba1-4deb-b25a-2095e72acd5f.jpg',
    color: '#b7b6b4',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/68f70a18-6eb9-4316-a615-3ccc2cb52b33.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/72b3939e-3e8a-48e8-9cd0-a096ee3bd595.jpg',
    tags: [ TagMaterialType.road ]
  },
  'ground-mud': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/36bd5480-b431-43cd-8dd4-9853dd87ada7.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/73e52ae7-3838-436d-a68e-a709a0814905.jpg',
    color: '#aea282',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bb651fd7-1b37-4c82-aa28-a91de574aa16.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bbf08cd8-d282-4ce4-a644-51a54c96e898.jpg',
    tags: [ TagMaterialType.road ]
  },
  'ground-cobblestone': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/384b6b47-2128-410b-a2ff-26efa4eb348a.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b242e733-a871-4613-af9f-56a8d4da14e6.jpg',
    color: '#a2a2a1',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/2058baa8-94f0-4ef1-992c-433a1030d6f5.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/99365eeb-707f-4b6e-96a5-a6f316324d46.jpg',
    tags: [ TagMaterialType.road ]
  },
  'ground-pavement': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f2b2d663-b431-47ac-82c4-58a9ef285629.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bf91cdd6-e556-4fc0-9ace-2c0dbef1fc21.jpg',
    color: '#a59390',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f8be9755-77df-49a4-b974-c48b086ff8a4.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f5c6fdf2-2923-4ef6-9217-29cbe6c34269.jpg',
    tags: [ TagMaterialType.road ]
  },
  'eames-dark-wood': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a1146953-a5bb-4399-a80b-40cbf7fecb29.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/eda6bfbb-5662-40be-8a63-e79b40cf1786.png',
    color: '#8a5032',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.plastic, TagMaterialType.wood, TagColor.white ]
  },
  'plant': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/19e8dd1b-920b-47cc-a8c6-1c206a64a531.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8d9e6956-24b7-489f-8796-6aeb6197627c.png',
    color: '#6b6c15',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05cbd5c7-c82b-4671-89cd-0feb3f919990.png',
    tags: [ TagMaterialType.wood, TagColor.green, TagMaterialType.road ]
  },
  'roofing-round-rooftiles-1': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/34743073-e805-4ebd-8248-3a6181b0e469.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c2699ccd-0fca-4891-875f-3cc033c7ce2e.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7cd34e61-db44-45f6-a38e-8e51011a5452.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8e08875d-643a-4754-a168-6d5147237566.jpg',
    color: '#B35C44',
    tags: [ TagMaterialType.roof, TagColor.red ]
  },
  'roofing-bitumen-1': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/9af4357b-964e-40d8-9a44-1bbf5b43c989.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/4c53b454-7b98-497e-b71f-14ac52385c7a.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bed6c714-671b-497c-9ce4-38061406673a.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3fa1d783-1e8a-4555-98bd-abc333f2e665.jpg',
    color: '#786561',
    tags: [ TagMaterialType.roof, TagColor.black ]
  },
  'roofing-metal-plated-1': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/598c02c7-d51a-4560-a76c-0fda4a869190.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/94a414d4-c99c-4dcb-b377-9da96042f323.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/e2c64779-ced6-4809-b8a3-7177a1cc4c14.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/50aa3f49-6f9f-4d94-8237-c4526fc75233.jpg',
    color: '#bdbab1',
    tags: [ TagMaterialType.roof, TagColor.gray ]
  },
  'roofing-square-rooftiles-1': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d019a4b4-001c-4728-9dbb-5372d0d1fb21.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/9d3e7c07-32fb-4d23-b5b4-e1decce5ff86.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5279a387-3955-409a-a27a-1bb8defa0c46.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bdbcc395-fa20-4ba7-ba68-26d74109fe31.jpg',
    color: '#8d4a37',
    tags: [ TagMaterialType.roof, TagColor.red ]
  },
  'ground-sand-1': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0a0263c2-7bcf-4d32-8992-12ea22564b78.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/74f5fa5d-fdd0-4c47-81ca-752da25eaf47.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a136ffeb-ba06-4a3a-a671-4c916efeebca.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1bce6d78-8c1b-4c9f-87a2-edee36f9f66d.jpg',
    color: '#8d4a37',
    tags: [ TagMaterialType.ground, TagColor.yellow ]
  },
  'metal-painted-1': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/9ef8f30b-5b3a-4f30-90a2-b6ba9241b774.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/21c5d748-bb9e-4c43-a414-7a5b480185d6.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/54cd1a30-40c8-43b1-9c1c-a5e13131b005.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8d923dc7-3613-42fc-b71a-f31c16cf9a45.jpg',
    color: '#8d4a37',
    tags: [ TagMaterialType.ground, TagColor.yellow ]
  },
  'metal-painted-2': {
    previewUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/37d35112-0833-4b3a-8b2e-0cba069919bb.png',
    textureUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b60d6b0a-fb4d-4408-8cef-ba332752a87c.jpg',
    normalsUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3c5c86d9-60e4-4aa2-9ef2-0f60e8159ad5.jpg',
    pbrUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7224be7f-4571-4ba9-8475-d9070b15a4b2.jpg',
    color: '#8d4a37',
    tags: [ TagMaterialType.wall, TagColor.yellow ]
  },
};
